"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const useRandom_1 = __importDefault(require("hooks/useRandom"));
const checkbox_1 = __importDefault(require("../checkbox/checkbox"));
const CheckboxListItem = ({ label, isLast = false, checked, onChange, ...props }) => {
    const id = (0, useRandom_1.default)();
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: "_py-4 _px-5 _d-flex _align-items-center", children: (0, jsx_runtime_1.jsx)(checkbox_1.default, { id: id, label: label, checked: checked, onChange: onChange, className: "_m-0", ...props }) }), !isLast && (0, jsx_runtime_1.jsx)("hr", { className: "_border-gray-200 _mx-4 _my-0" })] }));
};
exports.default = CheckboxListItem;
